export default {
  WELCOME_TOUR_COMPLETED: 'welcome_tour_completed',
  MULTILINGUAL_TOUR_COMPLETED: 'multilingual_tour_completed',
};
